import { MEGABYTE } from "../../constants/uploadPolicies";

export {
  BANK_STATEMENT_MAX_FILE_SIZE_MB,
  BOLETA_REGISTRAL_MAX_FILE_SIZE_MB,
  IDENTITY_MAX_FILE_SIZE_MB,
  LARGE_DOCUMENT_MAX_FILE_SIZE_MB,
  MEGABYTE,
  POWER_OF_ATTORNEY_MAX_FILE_SIZE_MB,
  PREDIAL_MAX_FILE_SIZE_MB,
  SIMPLE_DOCUMENT_MAX_FILE_SIZE_MB,
  TAX_DECLARATION_MAX_FILE_SIZE_MB,
} from "../../constants/uploadPolicies";

export function exceedsUploadTotalBytes(
  files: readonly ({ size?: number } | null | undefined)[],
  maxTotalBytes: number,
): boolean {
  let totalBytes = 0;
  for (const file of files) {
    totalBytes += file?.size ?? 0;
    if (totalBytes > maxTotalBytes) return true;
  }
  return false;
}

export function formatUploadLimit(maxBytes: number): string {
  const megabytes = maxBytes / MEGABYTE;
  return `${Number.isInteger(megabytes) ? megabytes : megabytes.toFixed(1)} MB`;
}
